import { TifTrainIcon } from '@/components/icons/tif/TifTrainIcon';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import { useSelector } from '@/store/utils';
import type { LegDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import { getPtModeIconName } from '@/utils/icon';
import { Icons } from '@packages/webshop-design-system';

export const TransportationTypeIcon = ({
  ptMode,
  width = 16,
  height = 16,
  className,
}: {
  ptMode: LegDTO['ptMode'];
  width?: number;
  height?: number;
  className?: string;
}) => {
  const iconName = getPtModeIconName(ptMode);
  const { value: tenant } = useSelector(tenantSelector);

  const IconComponent =
    tenant === 'tifrance' && ptMode?.code === 'TRAIN'
      ? TifTrainIcon
      : Icons[iconName];

  return (
    <IconComponent
      width={width}
      height={height}
      className={cn(className, { ['scale-[0.80]']: iconName === 'bus' })}
    />
  );
};
